<template>
<modal v-model="expense" :dir="['right', 'center']" :modalClass="['fill', 'sm']" title="Gasto" hideActions>

    <i class="options icon-dots-vertical" slot="options" v-if="expense && !expense.deleted_at" @click="Options([
        {text: 'Eliminar', class: 'error-color', if: canDelete , function: Delete, confirm: `¿Eliminar transacción de gasto?`, icon: 'trash'},
        {text: 'Editar', class: '', function: Edit, if: canEdit, icon: 'edit'}
    ])"></i>

    <div class="section flex column copyable" v-if="expense">
        <div class="mb15">
            <div class="bold">Gasto</div>
            <div>{{expense.type}}</div>
        </div>
        <div class="mb15">
            <div class="bold">Fecha</div>
            <div>{{Util.Date(expense.date, 'LLL')}}</div>
        </div>
        <div class="mb15">
            <div class="bold">Total</div>
            <div>{{Util.Price(expense.money)}}</div>
        </div>
        <div class="mb15" v-if="expense.money > 0">
            <div class="bold">Método de Pago</div>
            <div>{{Util.PayMethod(expense.pay_method)}}</div>
        </div>
        <div class="mb15">
            <div class="bold">Ingresado por</div>
            <div>{{expense.custom_data.created_by}}</div>
        </div>
        <div class="mb15" v-if="expense.custom_data.provider && expense.custom_data.provider.name">
            <div class="bold">Proveedor</div>
            <div>{{expense.custom_data.provider.name}} <span v-if="expense.custom_data.provider.rut && (expense.custom_data.provider.has_rut == undefined || expense.custom_data.provider.has_rut)">- {{ expense.custom_data.provider.rut }}</span></div>
        </div>
        <div class="mb15" v-if="expense.comment">
            <div class="bold">Comentario</div>
            <div>{{expense.comment}}</div>
        </div>
        <div class="mb15" v-if="expense.created_at && (expense.created_at !== expense.date)">
            <div class="bold">Fecha de creación</div>
            <div>{{Util.Date(expense.created_at, 'LLL')}}</div>
        </div>
        <div class="mb15 cyellow" v-if="expense.updated_at">
            <div class="bold">Editado</div>
            <div>{{Util.Date(expense.updated_at, 'LLL')}}</div>
            <div>{{expense.custom_data.updated_by}}</div>
        </div>

        <div class="mb15 cred" v-if="expense.deleted_at">
            <div class="bold">Eliminado</div>
            <div>{{Util.Date(expense.deleted_at, 'LLL')}}</div>
            <div>{{expense.custom_data.deleted_by}}</div>
        </div>
        

        <div class="mb15" v-if="!expense.expense_turn">
            <div class="bold cyellow"><i class="icon icon-circle-exclamation mr5"></i> No contabilizado en turno</div>
        </div>

        <input-files readonly label="Documentos" v-model="expense.custom_data.files" v-if="expense.custom_data.files && expense.custom_data.files.length"></input-files>
        <!--
        <div class="input-style selectable" v-if="expense.custom_data.image" @click="Util.Open(img(`documents/${expense.custom_data.image}`))">
            <div class="input-label">Documento</div>
            <div class="contain-img" :style="{'width': '100%', height: '200px', 'background-image': img(`documents/${expense.custom_data.image}`, true)}"></div>
        </div>
        -->
    </div>

</modal>
</template>
<script>
export default {
    data() {
        return {
            expense: null
        }
    },
    methods: {
        async Open(expense) 
        {
            if(typeof expense == 'number')
            {
                this.Loading();
                try {
                    expense = (await axios.get(`/expense/${expense}`)).data;    
                    this.Response({error: false});
                } catch (error) {
                    this.Response({error: true, reason: 'DATA_NULL'});
                }
                
            }
            this.expense = expense;
        },
        Delete() {
            this.Loading();
            axios.delete(`/expense/${this.expense.id}`).then(res => {
                this.Info('Gasto eliminado');
                this.$emit('OnTransactionDeleted', res.data);
                this.expense = null;
            }).catch(err => {
                this.Response(err);
            });
        },
        Edit() {
            let provider = this.expense.custom_data && this.expense.custom_data.provider ? this.expense.custom_data.provider : null;
            let data = {
                id: this.expense.id,
                type: this.expense.type,
                date: this.expense.date,
                money: this.expense.money,
                pay_method: this.expense.pay_method,
                comment: this.expense.comment,
                provider: provider,
                files: this.expense.custom_data.files ? this.expense.custom_data.files : [],
                add_date: true
            }

            this.$emit('OnTransactionExpenseEdited', data);
        }
    },
    computed: {
        canDelete() {
            if(!this.expense) return false;
            if(this.Auth.role.indexOf('admin') == -1) return false;
            return true;
            //var moment = require('moment');
            //return this.expense.date >= moment().unix() - (60*60*24*2);
        },
        canEdit() {
            let regex = /Agregado desde Factura N°/i;
            if(this.expense && this.expense.id_invoice) return false;
            if(this.expense && regex.test(this.expense.comment)) return false;
            return true;
        }
    }
}
</script>